import useAuthStore from "../../../../stores/useAuthStore";
import usePOSConfigStore from "../../../../stores/usePOSConfigStore";
import useCartStore from "../../../../stores/useCartStore";
import useTransactionStore from "../../../../stores/useTransactionStore";

export const QuantityDiscount = async (
  product,
  pricingRule,
  setCart,
  cart,
  orderType,
  cartObj,
  iscoupon,
  couponInput,
  uniqReferenceId,
  mPricingCouponId,
  mPricingRulesId,
  removeDiscounts
) => {
  const isExchange = useTransactionStore.getState().selectedReturnType === "EXCHANGE";
  const tillData = useAuthStore.getState().tillData;
  const saleTypeData = usePOSConfigStore.getState().saleTypeData || {};
  let taxIncludeFlag = saleTypeData?.customer?.istaxincluded === "Y" ? "Y" : tillData.tillAccess.csBunit.isTaxIncluded ? tillData.tillAccess.csBunit.isTaxIncluded : "Y";
  const saleTypeValidation = pricingRule?.cwrSaletypeId === null || orderType === undefined ? true : pricingRule?.cwrSaletypeId === orderType?.cwrSaletype?.cwrSaletypeId;
  let modificationsMade = false; // Flag to indicate modifications

  // Iterate through each item in the cart
  cartObj.items.map((item) => {
    let excludingFlag = true;

    const matchingCategory = pricingRule.mPricingPcategories.find((pc) => pc.mProductCategoryId === item.mProductCategoryId);
    if (
      (pricingRule.excludeProductCategories === "Y" && matchingCategory) ||
      (pricingRule.excludeProductCategories !== "Y" && !matchingCategory && pricingRule.mPricingPcategories.length > 0) ||
      (pricingRule.excludeProductCategories === "N" && pricingRule.mPricingPcategories.length === 0)
    ) {
      excludingFlag = false;
    }

    const matchingBrand = pricingRule.mPricingBrands.find((pc) => pc.mBrandId === item.productBrandId);
    if (
      (pricingRule.excludeBrands === "Y" && matchingBrand) ||
      (pricingRule.excludeBrands !== "Y" && !matchingBrand && pricingRule.mPricingBrands.length > 0) ||
      (pricingRule.excludeBrands === "N" && pricingRule.mPricingBrands.length === 0)
    ) {
      excludingFlag = false;
    }

    const matchingProductIndex = pricingRule.mPricingXProducts.findIndex((op) => op.mProductId === item.productId);
    if (
      (pricingRule.excludeProducts === "Y" && matchingProductIndex !== -1) ||
      (pricingRule.excludeProducts !== "Y" && matchingProductIndex === -1 && pricingRule.mPricingXProducts.length > 0) ||
      (pricingRule.excludeProducts === "N" && pricingRule.mPricingXProducts.length === 0)
    ) {
      excludingFlag = false;
    }

    let pricingRuleFlag = true;

    // Apply additional logic for pricingRuleFlag based on your requirements

    if (item.discount <= 0) {
      // console.debug("-----quantity")
      delete item.priority;
    }

    if (
      saleTypeValidation &&
      excludingFlag &&
      pricingRuleFlag &&
      (product.productId === item.productId || iscoupon || removeDiscounts) &&
      (item?.priority ? item?.priority < pricingRule.priority : true)
    ) {
      const offerIndex =
        pricingRule.mPricingXProducts.length > 0 && pricingRule.excludeProducts === "N"
          ? pricingRule.mPricingXProducts.findIndex((op) => op.mProductId === item.productId)
          : pricingRule.excludeProducts === "Y"
            ? pricingRule.mPricingXProducts.length > 0 && pricingRule.mPricingXProducts.findIndex((op) => op.mProductId !== item.productId)
            : 0;
      if (offerIndex >= 0) {
        let discountAmt = 0;
        if (pricingRule.mPricingQuantities.length > 0) {
          pricingRule.mPricingQuantities.forEach((qd) => {
            if (parseFloat(qd.quantity) === parseFloat(Math.abs(item.weight))) {
              if (pricingRule.discountType === "V") {
                discountAmt = parseFloat(qd.discountValue);
              } else {
                discountAmt = (qd.discountValue / 100) * parseFloat(item.realPrice);
              }
            }
          });
        }

        if (discountAmt > 0) {
          const prcPrecision = tillData.tillAccess.csBunit.currencies[0].prcPrecision;
          let sp, tax, nettotal;
          if (pricingRule.discountType === "V") {
            // Discount off the tax-inclusive gross — same treatment as TotalBillDiscount.js's
            // FD branch, so a flat "X off" discount reduces the payable total by exactly X
            // instead of also shrinking tax on top.
            const realPrice = parseFloat(item.realPrice);
            const taxInclude = (realPrice * item.taxRate) / 100;
            const gross = (taxIncludeFlag === "Y" ? realPrice : realPrice + taxInclude) * item.weight;
            // TSK-3145: cap at the line's own gross so a misconfigured/oversized flat
            // qd.discountValue can't push netAfterDiscount negative.
            discountAmt = gross >= 0 && discountAmt > gross ? gross : discountAmt;
            const netAfterDiscount = gross - discountAmt;
            tax = netAfterDiscount - netAfterDiscount / (1 + item.taxRate / 100);
            nettotal = netAfterDiscount;
            sp = item.weight !== 0 ? (netAfterDiscount - tax) / item.weight : 0;
          } else {
            sp = (parseFloat(item.realPrice) * item.weight - discountAmt) / item.weight;
            const mrp = parseFloat(sp) * item.weight;
            tax = taxIncludeFlag === "Y" ? mrp - mrp / (1 + item.taxRate / 100) : (mrp * item.taxRate) / 100;
            nettotal = taxIncludeFlag === "Y" ? mrp : mrp + tax;
          }
          item.salePrice = sp;
          item.taxAmount = parseFloat(tax.toFixed(prcPrecision));
          item.nettotal = parseFloat(nettotal.toFixed(prcPrecision));
          item.discount = discountAmt;
          item.discountName = pricingRule.printedName;
          item.mPricingruleId = pricingRule.mPricingrulesId;
          item.nextRule = pricingRule.nextRule;
          item.iscoupon = iscoupon;
          item.priority = pricingRule.priority;
          item.couponInput = couponInput;
          item.referenceId = uniqReferenceId;

          // Modifications made for the current item
          modificationsMade = true;
        } else {
          const mrp = parseFloat(item.realPrice) * item.weight;
          const tax = taxIncludeFlag === "Y" ? mrp - mrp / (1 + item.taxRate / 100) : (mrp * item.taxRate) / 100;
          item.taxAmount = parseFloat(tax.toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision));
          item.nettotal =
            taxIncludeFlag === "Y"
              ? parseFloat(mrp.toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision))
              : parseFloat((mrp + tax).toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision));
          item.discount = 0;
          item.discountName = "";
          item.mPricingruleId = null;
          delete item.nextRule;
        }
      }
    }
  });

  if (modificationsMade) {
    // Update the cart object with the adjusted items
    let couponsData = cart.couponInput?.length > 0 ? [...cart.couponInput] : [];
    if (!couponsData.some((coupon) => coupon.couponCode === couponInput) && couponInput !== undefined && couponInput !== null) {
      couponsData.push({ couponCode: couponInput, referenceId: uniqReferenceId, mPricingCouponId: mPricingCouponId, mPricingruleId: mPricingRulesId });
    }
    cartObj.iscoupon = iscoupon;
    cartObj.couponInput = couponsData;
    if (isExchange) {
      useCartStore.getState().setExchangeCart(cartObj);
    } else {
      setCart(cartObj);
    }
    return cartObj;
  }
};
